import { Box, Flex, FlexProps, Text } from '@chakra-ui/react';

type MarketplaceCardProps = FlexProps & {
  header?: string;
  headerBorderColor?: FlexProps['borderColor'];
};

const MarketplaceCard = ({
  header,
  headerBorderColor = 'grayMediumBackground',
  children,
  p,
  padding,
  ...rest
}: MarketplaceCardProps) => {
  const hasHeader = header != null;
  // px/py are longhand and would win over a consumer's `p` regardless of order, so drop them when `p`/`padding` is set
  const overridesPadding = hasHeader || p !== undefined || padding !== undefined;
  return (
    <Flex
      as={hasHeader ? 'section' : undefined}
      aria-label={header}
      direction="column"
      bg="white"
      borderWidth="1px"
      borderColor="grayMediumBackground"
      borderRadius="16px"
      px={overridesPadding ? undefined : { base: '22px', md: '32px' }}
      py={overridesPadding ? undefined : { base: '28px', md: '36px' }}
      p={hasHeader ? 0 : p}
      padding={padding}
      {...rest}
    >
      {hasHeader && (
        <Box
          px={{ base: '16px', md: '24px' }}
          py={{ base: '14px', md: '18px' }}
          borderBottomWidth="1px"
          borderBottomColor={headerBorderColor}
        >
          <Text fontSize={{ base: '15px', md: '17px' }} fontWeight="700" color="leaseEndBlue">
            {header}
          </Text>
        </Box>
      )}
      {children}
    </Flex>
  );
};

export default MarketplaceCard;
